import { AxiosResponse } from 'axios';
import api from './Api'

export const getBannerListForMobile = (): Promise<AxiosResponse<Array<IBanner>, any>> => {
    return api.get(`/mobile/banner`);
}